import { useEffect, useState } from "react";

import { calculateCreditUtilization } from "~/utils/creditUtilizationUtils";

interface ClientCreditData {
  utilized: number;
  available: number;
  percentage: number;
  insuredAmount: number;
  salesRequestUtilized: number;
  manualFacturasUtilized: number;
  uncollectedChecksAmount: number;
  portfolioChecksAmount: number;
  totalPendingAmount: number;
}

export function useOrderCreditUtilization(clientId: string) {
  const [clientCreditData, setClientCreditData] =
    useState<ClientCreditData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    const fetchCredit = async () => {
      setLoading(true);
      setError(null);
      try {
        const creditUtilizationData =
          await calculateCreditUtilization(clientId);

        setClientCreditData({
          utilized: creditUtilizationData.utilized,
          available: creditUtilizationData.available,
          percentage: creditUtilizationData.percentage,
          insuredAmount: creditUtilizationData.insuredAmount,
          salesRequestUtilized: creditUtilizationData.salesRequestUtilized,
          manualFacturasUtilized: creditUtilizationData.manualFacturasUtilized,
          uncollectedChecksAmount:
            creditUtilizationData.uncollectedChecksAmount,
          portfolioChecksAmount: creditUtilizationData.portfolioChecksAmount,
          totalPendingAmount: creditUtilizationData.totalPendingAmount,
        });
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    if (clientId) fetchCredit();
  }, [clientId]);

  return { clientCreditData, loading, error };
}
